import React, { createContext, JSX, useContext } from 'react';
import { AuthenticationLogic } from './authTypes';
import { useAuthenticationLogic } from './useAuthenticationLogic';

const AuthContext = createContext<AuthenticationLogic | null>(null);

function AuthProvider({ children }: { children: React.ReactNode }): JSX.Element {
  const auth = useAuthenticationLogic();

  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
}

function useAuth(): AuthenticationLogic {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}

export type {
  AuthState,
  EmailVerificationRequest,
  LoginRequest,
  PasswordResetRequest,
  ResendVerificationRequest,
} from './authTypes';

export type {
  CreateCandidateRequest,
  CreateEmployerRequest,
  GuestConversionRequest,
} from '../services/api-client';

export { AuthProvider, useAuth, useAuthenticationLogic };
export { ProtectedRoute } from './ProtectedRoute';
